







































































import Vue from "vue";
import NavbarTitle from "@/components/Text/Navbar/NavbarTitle.vue";
import NavbarSubtitle from "@/components/Text/Navbar/NavbarSubtitle.vue";
import NavbarSubSubtitle from "@/components/Text/Navbar/NavbarSubSubTitle.vue";
import { store } from "@/store/store";

interface LeftBarData {
  items: Array<{
    title: string;
    children: Array<{
      title: string;
      link: string;
      children?: Array<{
        title: string;
        link: string;
      }>;
    }>;
  }>;
}

export default Vue.extend({
  name: "LeftBar",
  components: {
    NavbarTitle,
    NavbarSubtitle,
    NavbarSubSubtitle
  },
  methods: {
    displayTitle(): LeftBarData {
      const view = store.getters.GET_VIEW as string;
      if (
        view === "ADMIN" ||
        store.getters.AGENCE_BY_ID[view].name.toUpperCase() === "PARIS" ||
        store.getters.AGENCE_BY_ID[view].name.toUpperCase() === "LYON"
      ) {
        return {
          items: [
            {
              title: "Management",
              children: [
                { title: "Vue D'ensemble", link: "/dashboard" },
                {
                  title: "Appareils",
                  link: "/devices?page=table",
                  children: [
                    { title: "Vignette", link: "/devices?page=card" },
                    { title: "Graphique", link: "/devices?page=graph" }
                  ]
                },
                { title: "Enquêtes", link: "/surveys" },
                { title: "Logs", link: "/logs" }
              ]
            },
            {
              title: "Administration",
              children: [{ title: "Utilisateurs", link: "/users" }]
            }
          ]
        };
      } else {
        return {
          items: [
            {
              title: "Management",
              children: [
                { title: "Vue D'ensemble", link: "/dashboard" },
                { title: "Appareils", link: "/devices?page=table" },
                { title: "Logs", link: "/logs" }
              ]
            }
          ]
        };
      }
    }
  }
});
